import { baseQuery } from '../baseQuery';

export const postVoipCall = async (number: string) => {
  const { data } = await baseQuery('voip-call', {
    type: 'POST',
    body: {
      number,
    },
  });

  return data;
};
